import { computed, signal } from "@preact/signals-react"

export const adminNewListedFormTitle = signal(null)
export const adminNewListedFormRowData = signal({})
export const adminNewListedErrorFormData = signal({})
export const adminNewListedFormIsLoading = signal(null)
export const adminNewListedFormIsSkuMappingData = signal(false)
export const brandForm = signal([])
export const skuForm = signal([])
export const siteForm = signal([])

export const adminNewListedFormIsOpen = computed(() => adminNewListedFormTitle.value !== null)